import { render, staticRenderFns } from "./buyings.vue?vue&type=template&id=1cbff85a&scoped=true&lang=html&"
import script from "./buyings.vue?vue&type=script&lang=js&"
export * from "./buyings.vue?vue&type=script&lang=js&"
import style0 from "./buyings.vue?vue&type=style&index=0&id=1cbff85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbff85a",
  null
  
)

export default component.exports